module.exports = __webpack_public_path__ + "images/sc.png?c52938d98c855f91f3be0c7ed2dcb772";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sc.png
// module id = 54
// module chunks = 0